import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "View",
  "use": "View-usage",
  "viewBox": "0 0 62 39",
  "content": "<symbol viewBox=\"0 0 62 39\" xmlns=\"http://www.w3.org/2000/svg\" id=\"View\"><g fill-rule=\"evenodd\"><circle cx=\"30.746\" cy=\"18.5\" r=\"12.5\" /><path d=\"M.024 19A.763.763 0 0 1 0 18.826h.077c1.699-4.802 31.248-39.952 61.79.174H62l-.066.087.066.087h-.132c-30.544 40.127-60.093 4.81-61.791 0H0c0-.049.008-.107.024-.174zm5.058 0h51.836c-25.41-32-51.836-2.38-51.836 0zm0 0h51.836C32.525 51 5.082 21.38 5.082 19z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol